<div class="common-table relay-word-wrap mt-0">
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Key</th>
        <th>Value</th>
        <th *ngIf="entityType === TYPE_ENDPOINT">Hidden</th>
        <th class="text-center" *ngIf="showGlobalBox">Global</th>
        <th width="15%" class="text-center">Options</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="entityType === TYPE_ENDPOINT">
        <tr>
          <td>
            <input type="text" placeholder="key" class="form-control form-control-sm" [(ngModel)]="extractedObject.key" />
          </td>
          <td>
            <input type="text" placeholder="path" class="form-control form-control-sm" [(ngModel)]="extractedObject.value" />
          </td>
          <td class="text-center justify-content-center" style="vertical-align: middle !important">
            <input type="checkbox" id="storeHidden" [(ngModel)]="extractedObject.hidden" />
          </td>
          <td class="text-center justify-content-center" *ngIf="showGlobalBox" style="vertical-align: middle !important">
            <input type="checkbox" id="storeInGlobal" [(ngModel)]="extractedObject.storeInGlobal"/>
          </td>
          <td class="text-center">
            <button class="btn relay-btn primary" (click)="addToExtractedParams()"
            [ngClass]="{ 'anchor-tag-disabled': !extractedObject.key || !extractedObject.value }">
            ADD
          </button>
          </td>
        </tr>
        <tr *ngFor="let param of respExtParams | keyvalue">
          <td name="key">{{ param?.key }}</td>
          <td name="value">{{ param?.value }}</td>
          <td class="text-center justify-content-center">
            <input type="checkbox" id="storeHidden" (change)="editHidden(param.key)"  [checked]="checkForHidden(param.key)"  />
          </td>
          <td class="text-center" *ngIf="showGlobalBox">
            <input type="checkbox" name="storeInGlobal" [(ngModel)]="extractedObject.storeInGlobal" (change)="addToExtractedParams()"/>
          </td>
          <td class="text-center">
            <i class="fas fa-trash-alt text-danger" name="remove-extractor" (click)="removeFromExtractedParams(param.key)" title="Remove Extractor Key"></i>
          </td>
        </tr>
      </ng-container>

      <ng-container *ngIf="entityType === TYPE_TESTCASE">
        <tr>
          <td>
            <input type="text" placeholder="key" class="form-control form-control-sm" [(ngModel)]="extractedObject.displayValue" />
          </td>
          <td>
            <input type="text" placeholder="value" class="form-control form-control-sm" [(ngModel)]="extractedObject.pathToExtract" />
          </td>
          <td class="text-center justify-content-center" *ngIf="showGlobalBox" style="vertical-align: middle !important">
            <input type="checkbox" [(ngModel)]="extractedObject.storeInGlobal"/>
          </td>
          <td class="text-center">
            <button class="btn relay-btn primary" (click)="addToExtractedParams()"
              [ngClass]="{ 'anchor-tag-disabled': !extractedObject.displayValue || !extractedObject.pathToExtract }">
              ADD
            </button>
          </td>
        </tr>
        <tr *ngFor="let param of respExtParams; index as index" [hidden]="param.responseSource !== responseType">
          <td name="displayValue">{{ param.displayValue }}</td>
          <td name="pathToExtract">{{ param.pathToExtract }}</td>
          <td class="text-center" *ngIf="showGlobalBox">
            <input type="checkbox" name="storeInGlobal" [(ngModel)]="param.storeInGlobal" (change)="addToExtractedParams()"/>
          </td>
          <td class="text-center">
            <i
            class="fa fa-plus-circle text-primary clickable mr-1"
            (click)="addtoValidation(param)"
            title="Add to Validation"
          ></i>
            <i
            class="fas fa-edit text-primary clickable mr-1"
            (click)="editParam(index)"
            title="Edit Extractor Key"
          ></i>
            <i
              class="fas fa-info-circle clickable"
              *ngIf="param.canDelete !== null && !param.canDelete"
              placement="left"
              ngbTooltip="Response extractor is used in testdata/validation"
            ></i>
            <i
              class="fas fa-trash-alt text-danger clickable"
              *ngIf="param.canDelete === null || param.canDelete"
              (click)="removeFromExtractedParams(param.displayValue, index)"
              title="Remove Extractor Key"
            ></i>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <div class="row">
    <div class="col">
      <div class="form-check form-check-inline mt-2" *ngIf="entityType !== TYPE_TESTCASE">
        <input class="form-check-input" name="syncUpdateToTestCase" type="checkbox" [(ngModel)]="syncUpdateToTestCase" />
        <label class="form-check-label" for="inlineCheckbox1">Sync to Testcase</label>
      </div>
    </div>
  </div>
</div>
